import React from 'react'
import Control from './Control'

export default class Label extends Control {

    //className title
    render() {
        return <label className={this.props.className || this.props.cn || this.props.ccn }>{this.props.children}</label>
    }
}